import React, { FC } from 'react';
import { ReactComponent as PrevArrowIcon } from '../../../../assets/icons/prev-arrow.svg';
import { ReactComponent as NextArrowIcon } from '../../../../assets/icons/next-arrow.svg';
import './clicker.scss';
import { ISubSlideCarouselComponentsProps } from '../presenter-slide-carousel';
import { observer } from 'mobx-react';
import FullscreenIcon from '../../../../assets/icons/slides-fullscreen-button.svg';
import TransparentButton from '../../../shared/transparent-button/transparent-button';

const Clicker: FC<ISubSlideCarouselComponentsProps> = ({
  onNextSlideHandler,
  onPrevSlideHandler,
  numberOfSlides,
  currentSlideIndex,
  prevArrowDisabledClass,
  nextArrowDisabledClass,
  onFullscreenHandler
}): JSX.Element => {
  const additionalIndex = 1;

  return (
    <div className="clicker">
      <div className="slide-count">
        <TransparentButton onClick={onFullscreenHandler} customClasses='clicker-fullscreen-button'>
          <img src={FullscreenIcon} alt='Full screen icon'/>
        </TransparentButton>
        <span>
          Slide {currentSlideIndex + additionalIndex} of {numberOfSlides}
        </span>
      </div>
      <div className="clicker__row-wrapper">
        <div className={`clicker__arrow clicker__arrow_prev-arrow ${prevArrowDisabledClass}`} onClick={onPrevSlideHandler}>
          <PrevArrowIcon/>
        </div>
        <div className={`clicker__arrow clicker__arrow_next-arrow ${nextArrowDisabledClass}`} onClick={onNextSlideHandler}>
          <NextArrowIcon/>
        </div>
      </div>
    </div>
  );
};

export default observer(Clicker);
